<template>
  <div>
    <a-input-search placeholder="input search text" enter-button @search="onSearch"/>
    <br /><br />
    <a-table :columns="columns" :data-source="data">
      <a slot="active" slot-scope="text,record"  @click="getactive(record.sn)">激活码</a>
      <a slot="action" slot-scope="text,record"  @click="handleEdit(record.sn)">编辑</a>
    </a-table>  
  </div>
</template>
<script>
const columns = [
        {
          title: '设备号',
          dataIndex: 'sn',
          scopedSlots: { customRender: 'name' },
        },{
          title: '激活码',
          dataIndex: 'active',
          scopedSlots: { customRender: 'active' },
        },
        {
          title: '编辑',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ];



export default {
  data() {
    let param = {
        page:1,
        pagenum:10
    }
    let terminallist;
    let obj = this.$qs.stringify(param)
    this.$axios({
      method:'post',
      url:'/api/terminal/list',
      data: obj
    }).then((response) =>{          //这里使用了ES6的语法
       this.data = response.data
       this.Showpage = true
       console.log(response)       //请求成功返回的数据
    }).catch((error) =>{
         console.log(error)       //请求失败返回的数据       
    })
    return {
      Showpage:false,
      data:terminallist,
      columns
    };
  },
  methods:{
    handleEdit(key){
      this.$store.state.terminalid = key;
      this.$router.push('/home/newterminal');
    },
    getactive(key){
      this.$store.state.terminalid = key;
      this.$router.push('/home/terminalactive');
    },
    handleAdd() {
      this.$router.push('/home/newterminal');
    },
    onSearch(value){
      this.$store.state.terminalid = value;
      this.$router.push('/home/terminalactive');
    }
    
  },
};
</script>



// WEBPACK FOOTER //
// src/components/TerminalList.vue